import React from "react";
import {
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const KmPageTitle = (props) => {
  const classes = useStyles();

  return (
    <Typography gutterBottom color="textPrimary" variant="h2" component="h2" className={classes.title}>
      {props.children}
    </Typography>
  );
};

export default KmPageTitle;
